
import { GameRole } from '../../types/game';
import { skills } from '../skills';
import { challenges } from '../challenges';

export const energyRole: GameRole = {
  id: 'energy',
  title: 'Energy Strategist',
  description: 'Focus on optimizing energy consumption and sourcing for mining operations. Navigate energy markets, negotiate contracts, and implement renewable solutions.',
  difficulty: 'Medium',
  strengths: [
    'Best energy cost optimization',
    'Strong in renewable integration',
    'Excellent at cost reduction'
  ],
  startingSkills: [
    skills.find(s => s.id === 'renewable-energy')!
  ],
  careerPath: [
    {
      level: 'Junior',
      title: 'Energy Strategist',
      requiredExperience: 0,
      requiredYears: 0
    },
    {
      level: 'Mid-Level',
      title: 'Senior Energy Strategist',
      requiredExperience: 150,
      requiredYears: 3
    },
    {
      level: 'Senior',
      title: 'Energy Director',
      requiredExperience: 350,
      requiredYears: 6
    },
    {
      level: 'Leader',
      title: 'Chief Energy Officer',
      requiredExperience: 700,
      requiredYears: 10
    }
  ],
  specialChallenges: [
    challenges.find(c => c.id === 'power-opportunity')!
  ],
  careerObjectives: [
    {
      title: 'Green Mining Pioneer',
      description: 'Achieve 50% renewable energy usage',
      target: {
        kpi: 'energyCost',
        value: 0.05
      },
      reward: 'Renewable Champion Badge'
    }
  ]
};
